import * as cx from 'classnames';
import { counties } from 'mk/autogenerated/geoData';
import { PLACES } from 'mk/autogenerated/geoDataPlaces';
import {
    DO_NOT_WANT_TO_TELL,
    HOME_SIGNUP_BAZAAR,
    HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link,
    HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link,
    HOME_SIGNUP_LOGIN_HERE,
    HOME_SIGNUP_PRIVACY,
    HOME_SIGNUP_VOP,
    PREGNANCY_STATE,
    PREGNANT,
    SETTINGS_I_LIVE_ABROAD,
    SIGN_UP_AND_HAVE_PROFIT_IT_TAKES_ONLY_ONE_MINUTE_AND_IS_FREE,
    SIGNUP_BUTTON,
    SIGNUP_DUE_DATE,
    SIGNUP_EMAIL,
    SIGNUP_LOCATION_COUNTRY,
    SIGNUP_LOCATION_COUNTY,
    SIGNUP_LOCATION_PLACE,
    SIGNUP_PASSWORD,
    SIGNUP_USERNAME,
    WE_ARE_TRYING_TO_CONCEIVE,
    WE_HAVE_CHILDREN,
} from 'mk/autogenerated/translations/SignupForm.1be23a6bf5580d82daa32175ded55b14'
import { about_privacy_url, about_rules_bazaar_url, about_rules_common_url } from 'mk/urls/functions';
import { UtmQuery } from 'mk2/apps/home/schemas';
import { PregnancyState } from 'mk2/apps/settings/schemas';
import * as usersUrls from 'mk2/apps/users/urls';
import DateSelectField from 'mk2/components/forms/DateSelectField';
import InputField from 'mk2/components/forms/InputField';
import PasswordField from 'mk2/components/forms/PasswordField';
import SelectField, { Option } from 'mk2/components/forms/SelectField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import * as React from 'react';
import styles from './SignupForm.mscss';

export const SIGNUP_FORM_NAME = 'SIGNUP_FORM';

interface OwnProps {
    simple: boolean;
    iframe: boolean;
    query: UtmQuery;
    divRef?: React.RefObject<HTMLDivElement>;
    initialValues: SignupFormData;
    onStoreEvent(name: string, props: any);
    onSignup(values: SignupFormData);
}

interface OwnState {
    showDueDate: boolean;
    countyId: number;
    passwordAutofillTriggered: boolean;
    usernameAutofillTriggered: boolean;
}

export interface SignupFormData {
    username: string;
    password: string;
    email: string;
    locationCounty?: string;
    place?: string;
    pregnancyState?: string;
    dueDate?: string;
}

type Props = OwnProps;

const PREGNANCY_STATE_CHOICES: Option[] = [
    { value: null, label: '', isPlaceholder: true },
    { value: PregnancyState.Pregnant, label: PREGNANT },
    { value: PregnancyState.Trying, label: WE_ARE_TRYING_TO_CONCEIVE },
    { value: PregnancyState.HasChildren, label: WE_HAVE_CHILDREN },
    { value: PregnancyState.DoNotTell, label: DO_NOT_WANT_TO_TELL },
];

class SignupFormComponent extends React.Component<Props & MKReduxFormInjectedProps, OwnState> {
    constructor(props: Props & MKReduxFormInjectedProps) {
        super(props);

        this.state = {
            showDueDate: false,
            countyId: -1,
            passwordAutofillTriggered: false,
            usernameAutofillTriggered: false,
        };
    }

    public componentDidMount() {
        const { onStoreEvent, query } = this.props;
        onStoreEvent('signup_visited', {
            utm_campaign: query.utm_campaign
                ? query.utm_campaign
                : query.mkutm_campaign
                    ? query.mkutm_campaign
                    : null,
            utm_medium: query.utm_medium
                ? query.utm_medium
                : query.mkutm_medium
                    ? query.mkutm_medium
                    : null,
            utm_source: query.utm_source
                ? query.utm_source
                : query.mkutm_source
                    ? query.mkutm_source
                    : null,
            utm_content: query.utm_content
                ? query.utm_content
                : query.mkutm_content
                    ? query.mkutm_content
                    : null,
        });
    }

    public render() {
        const { simple, iframe, handleSubmit } = this.props;

        const countiesOptions = () => {
            return [{ value: '', label: '', isPlaceholder: true }]
                .concat(
                    counties.map((county) => {
                        return {
                            value: county[0].toString(),
                            label: county[1],
                            isPlaceholder: false,
                        };
                    }),
                )
                .concat({ value: '0', label: SETTINGS_I_LIVE_ABROAD, isPlaceholder: false });
        };

        const placesOptions = () => {
            return [{ value: '', label: '', isPlaceholder: true }].concat(
                PLACES.filter((place) => place[2] === this.state.countyId).map((p) => {
                    return { value: p[0].toString(), label: p[1], isPlaceholder: false };
                }),
            );
        };

        return (
            <div
                ref={this.props.divRef}
                className={cx(styles.SignupForm, iframe && styles[`SignupForm--iframe`])}
            >
                {!iframe && (
                    <div
                        className={styles.SignupForm__cta}
                        dangerouslySetInnerHTML={{
                            __html: SIGN_UP_AND_HAVE_PROFIT_IT_TAKES_ONLY_ONE_MINUTE_AND_IS_FREE,
                        }}
                    />
                )}
                <form className={styles.SignupForm__form} onSubmit={handleSubmit}>
                    <InputField
                        name="email"
                        type="text"
                        label={SIGNUP_EMAIL}
                        marginLeft={false}
                        transparent={iframe}
                    />
                    <PasswordField
                        name="password"
                        label={SIGNUP_PASSWORD}
                        marginLeft={false}
                        onAutofill={this.handlePasswordAutofill}
                        minimizedLabel={this.state.passwordAutofillTriggered}
                        transparent={iframe}
                    />
                    <InputField
                        name="username"
                        type="text"
                        label={SIGNUP_USERNAME}
                        marginLeft={false}
                        transparent={iframe}
                        onAutofill={this.handleUsernameAutofill}
                        minimizedLabel={this.state.usernameAutofillTriggered}
                    />
                    {!simple && (
                        <>
                            <SelectField
                                name="locationCounty"
                                label={SIGNUP_LOCATION_COUNTY}
                                options={countiesOptions()}
                                marginLeft={false}
                                onChange={this.handleSelectCounty}
                                transparent={iframe}
                            />
                            {this.state.countyId >= 0 ? (
                                <SelectField
                                    name="place"
                                    options={placesOptions()}
                                    label={
                                        this.state.countyId > 0
                                            ? SIGNUP_LOCATION_PLACE
                                            : SIGNUP_LOCATION_COUNTRY
                                    }
                                    marginLeft={false}
                                    transparent={iframe}
                                />
                            ) : null}
                            <SelectField
                                name="pregnancyState"
                                label={PREGNANCY_STATE}
                                options={PREGNANCY_STATE_CHOICES}
                                marginLeft={false}
                                onChange={this.handlePregnancyStateChange}
                                transparent={iframe}
                            />
                            {this.state.showDueDate && (
                                <DateSelectField
                                    name="dueDate"
                                    label={SIGNUP_DUE_DATE}
                                    marginLeft={false}
                                    yearFrom={new Date().getFullYear()}
                                    yearTo={
                                        new Date().getMonth() > 3
                                            ? new Date().getFullYear() + 1
                                            : new Date().getFullYear()
                                    }
                                    transparent={iframe}
                                />
                            )}
                        </>
                    )}
                    <SubmitButton
                        className={styles.SignupForm__button}
                        formName={SIGNUP_FORM_NAME}
                        label={SIGNUP_BUTTON}
                        disableIfNotDirty={false}
                    />
                </form>

                <p className={styles.SignupForm__legal}>
                    <Interpolate
                        i18nKey={
                            HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link
                        }
                        bazaar_link={<a href={about_rules_bazaar_url()}>{HOME_SIGNUP_BAZAAR}</a>}
                        privacy_link={<a href={about_privacy_url()}>{HOME_SIGNUP_PRIVACY}</a>}
                        common_link={<a href={about_rules_common_url()}>{HOME_SIGNUP_VOP}</a>}
                    />
                </p>
                <p className={styles.SignupForm__signin}>
                    <Interpolate
                        i18nKey={HOME_SIGNUP_IF_REGISTERED_LOGIN_HERE_link}
                        link={<Link to={usersUrls.login}>{HOME_SIGNUP_LOGIN_HERE}</Link>}
                        useDangerouslySetInnerHTML
                    />
                </p>
            </div>
        );
    }

    private handlePasswordAutofill = () => {
        this.setState({ passwordAutofillTriggered: true });
    };

    private handleUsernameAutofill = () => {
        this.setState({ usernameAutofillTriggered: true });
    };

    private handleSelectCounty = (event) => {
        this.setState({ countyId: parseInt(event.currentTarget.value, 10) });
    };

    private handlePregnancyStateChange = (event) => {
        if (event.currentTarget.value === '1') {
            this.setState({ showDueDate: true });
        } else {
            this.setState({ showDueDate: false });
        }
    };
}

export const SignupForm = mkReduxFormNew<SignupFormData, Props>({
    formName: SIGNUP_FORM_NAME,
    onValidate: () => ({
        /* nothing to do */
    }),
    onSave: (values, props) => props.onSignup(values),
    disableDirtyCheck: true,
})(SignupFormComponent);
